import React from 'react'

import Table from 'react-bootstrap/Table';
import "./ugpg.css"
import Accordion from 'react-bootstrap/Accordion';



const UG = () => {
   
  return (
   <>
 
   <div className="ug-body">
   
   
   <Accordion>
   <Accordion.Item eventKey="0">
        <Accordion.Header> <div className="batch">BATCH 2023</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhijeet Singh Parihar</td>
          <td>230005001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Abhinav Gurrapu</td>
          <td>230005002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Aditya Kumar Prasad</td>
          <td>230005003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Amruthansh Gupta</td>
          <td>230005004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Ansh Kyal</td>
          <td>230005005</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Anurag E Prasad</td>
          <td>230005006</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Asmatunnisa Baig</td>
          <td>230005007</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Atiharsh Bhatt</td>
          <td>230005008</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Ayush Kumar Gupta</td>
          <td>230005009</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Bhukya Suresh</td>
          <td>230005010</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Bhumika Aggarwal</td>
          <td>230005011</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Burra Vijyusha</td>
          <td>230005012</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Cheepati Gireesh Kumar Reddy</td>
          <td>230005013</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Deendayal Suthar</td>
          <td>230005014</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Eata Sai Suraj</td>
          <td>230005015</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Harsh Anand</td>
          <td>230005016</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Harsh Bhati</td>
          <td>230005017</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Harshit Kumar</td>
          <td>230005018</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>J Shiva</td>
          <td>230005019</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Kale Swarangi Keshav</td>
          <td>230005020</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Keerthan A</td>
          <td>230005021</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Kondeti Praveen Kumar</td>
          <td>230005022</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Kushagra Shrikhande</td>
          <td>230005024</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Mannuru Praneetha</td>
          <td>230005025</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Manurkar Pranav Padmakar</td>
          <td>230005026</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Mayank Kumar</td>
          <td>230005027</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Mohit Garhewal</td>
          <td>230005028</td>
      
        </tr>
        <tr>
          <td>28</td>
          <td>Monoranjan Roy</td>
          <td>230005029</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Muggu Jaya Sree</td>
          <td>230005030</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Mukund Narayan Jha</td>
          <td>230005031</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Nawed Ashraf</td>
          <td>230005032</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Ommkar Sahoo</td>
          <td>230005033</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>P Pragathi</td>
          <td>230005034</td>
        
        </tr>
        <tr>
          <td>34</td>
          <td>Pohrselvan S.S</td>
          <td>230005035</td>
        
        </tr>
        <tr>
          <td>35</td>
          <td>Ramavath Sunil Kumar</td>
          <td>230005036</td>
        
        </tr>
        <tr>
          <td>36</td>
          <td>Rishabh Patel</td>
          <td>230005038</td>
        
        </tr>
        <tr>
          <td>37</td>
          <td>Rudresh Pratap Singh</td>
          <td>230005039</td>
        
        </tr>
        <tr>
          <td>38</td>
          <td>Sahajmeet Kaur</td>
          <td>230005040</td>
        
        </tr>
        <tr>
          <td>39</td>
          <td>Sai Abhilash Dash</td>
          <td>230005041</td>
        
        </tr>
        <tr>
          <td>40</td>
          <td>Samridhi</td>
          <td>230005042</td>
        
        </tr>
        <tr>
          <td>41</td>
          <td>Sanat Kumar Shukla</td>
          <td>230005043</td>
        
        </tr>
        <tr>
          <td>42</td>
          <td>Saumya Sharma</td>
          <td>230005044</td>
        
        </tr>
        <tr>
          <td>43</td>
          <td>Saksham Kumar Nigam</td>
          <td>230005045</td>
        
        </tr>
        <tr>
          <td>44</td>
          <td>Shivam Bajaj</td>
          <td>230005046</td>
        
        </tr>
        <tr>
          <td>45</td>
          <td>Shubham Prajapati</td>
          <td>230005047</td>
        
        </tr>
        <tr>
          <td>46</td>
          <td>Utkarsh Mittal</td>
          <td>230005049</td>
        
        </tr>
        <tr>
          <td>47</td>
          <td>Vani Agarwal</td>
          <td>230005050</td>
        
        </tr>
        <tr>
          <td>48</td>
          <td>Vihaan Singh</td>
          <td>230005051</td>
        
        </tr>
        <tr>
          <td>49</td>
          <td>Yash Vardhan Solanki</td>
          <td>230005052</td>
        
        </tr>
        
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
   <Accordion.Item eventKey="1">
        <Accordion.Header> <div className="batch">BATCH 2022</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        
        <tr>
          <td>1</td>
          <td>Abhishek A.P</td>
          <td>220005001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Abhishek Jha</td>
          <td>220005002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Aditi Tapdiya</td>
          <td>220005003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Aditya Kishan Sonkusare</td>
          <td>220005004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Aditya Nimadi</td>
          <td>220005005</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Akarshit Trivedi</td>
          <td>220005006</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Amber Verma</td>
          <td>220005008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Anjaneya Parashar</td>
          <td>220005009</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Anubhuti Sharma</td>
          <td>220005010</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Apekshit</td>
          <td>220005011</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Arunabha Dhal</td>
          <td>220005012</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Ashmi Chandak</td>
          <td>220005013</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Ashwin Bansod</td>
          <td>220005014</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Atharva Porwal</td>
          <td>220005015</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Avdhoot Ramchandra Kasture</td>
          <td>220005016</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Devarapalli Nissi</td>
          <td>220005017</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Dhruv Jain</td>
          <td>220005018</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Dikshit Suthar</td>
          <td>220005019</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Divya Singh Maurya</td>
          <td>220005020</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Gaurav Kumar</td>
          <td>220005021</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Gauttam Mandan</td>
          <td>220005022</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Godishala Varshith</td>
          <td>200005023</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Guguloth Sai Tharun</td>
          <td>220005024</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Gyanu Sahu</td>
          <td>220005025</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Harshit Gupta</td>
          <td>220005026</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Jadhav Krupanand</td>
          <td>220005027</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Kanika Upadhaya</td>
          <td>220005028</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>Kashaboina Sai Lokesh</td>
          <td>220005029</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Katroth Srikanth</td>
          <td>220005030</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Ketali Dhurvey</td>
          <td>220005031</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Lingampalli Nishanth</td>
          <td>220005032</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Lokery Kiranmayi</td>
          <td>220005033</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Madhav Rathore</td>
          <td>220005034</td>
        
        </tr>
        <tr>
          <td>34</td>
          <td>Mansi Tanwar</td>
          <td>220005035</td>
        
        </tr>
        <tr>
          <td>35</td>
          <td>Mrunal Chandrashekhar Nandpure</td>
          <td>220005036</td>
        
        </tr>
        <tr>
          <td>36</td>
          <td>Nikhil</td>
          <td>220005037</td>
        
        </tr>
        <tr>
          <td>37</td>
          <td>Prasoon Pandey</td>
          <td>220005038</td>
        
        </tr>
        <tr>
          <td>38</td>
          <td>Pratik Prajn</td>
          <td>220005039</td>
        
        </tr>
        <tr>
          <td>39</td>
          <td>Raj Sharma</td>
          <td>220005040</td>
        
        </tr>
        
        <tr>
          <td>40</td>
          <td>Rishabh Sharma</td>
          <td>220005042</td>
        
        </tr>
        <tr>
          <td>41</td>
          <td>Rishabh Singh</td>
          <td>220005043</td>
        
        </tr>
        <tr>
          <td>42</td>
          <td>S S K Chandrahaas</td>
          <td>220005044</td>
        
        </tr>
        <tr>
          <td>43</td>
          <td>Saikumar</td>
          <td>220005045</td>
        
        </tr>
        <tr>
          <td>44</td>
          <td>Sakshi Sahadeo Dombe</td>
          <td>220005046</td>
        
        </tr>
        <tr>
          <td>45</td>
          <td>Sanket Panigrahi</td>
          <td>220005047</td>
        </tr>
        <tr>
          <td>46</td>
          <td>Shivansh Malpani</td>
          <td>220005048</td>
        </tr>
        <tr>
          <td>47</td>
          <td>Shivendra Singh Jaroliya</td>
          <td>220005049</td>
        </tr>
        <tr>
          <td>48</td>
          <td>Shreyans Kothari</td>
          <td>220005050</td>
        </tr>
        <tr>
          <td>49</td>
          <td>Stuti Bhauguna</td>
          <td>220005051</td>
        </tr>
        <tr>
          <td>50</td>
          <td>Swaraj mahendra Khair</td>
          <td>220005052</td>
        </tr>
        <tr>
          <td>51</td>
          <td>Tatpar Sundaria</td>
          <td>220005053</td>
        </tr>
        <tr>
          <td>52</td>
          <td>Trishant Kumar Talluri</td>
          <td>220005054</td>
        </tr>
        <tr>
          <td>53</td>
          <td>Ujjwal Choudhary</td>
          <td>220005055</td>
        </tr>
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
   <Accordion.Item eventKey="2">
        <Accordion.Header> <div className="batch">BATCH 2021</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Aaditya Choubey</td>
          <td>210005001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Abhishek Kumar</td>
          <td>210005002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Abhishek Yadav</td>
          <td>210005003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Ahsan Habib Laskar</td>
          <td>210005004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Amirthan Arul</td>
          <td>210005005</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Ananya Pathak</td>
          <td>210005006</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Aniket Mandawkar</td>
          <td>210005007</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Anjelo Saju</td>
          <td>210005008</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Ayush Shukla</td>
          <td>210005011</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Ayushman Jaiswal</td>
          <td>210005012</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Bhimanshu Durge</td>
          <td>210005014</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Brijlal Nimore</td>
          <td>210005015</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Chirag Gour</td>
          <td>210005016</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Dadireddy Navya</td>
          <td>210005017</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Digvijay Singh Sastiya</td>
          <td>210005018</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Ezhini Rasendiran R</td>
          <td>210005019</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Geetika Tirumalasetty</td>
          <td>210005020</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Ishan Mohan Shrivastava</td>
          <td>210005021</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Ishita Sharma</td>
          <td>210005022</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Jaswant Singh Chouhan</td>
          <td>210005023</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Jay Dhurve</td>
          <td>210005024</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Jitendra Sahu</td>
          <td>210005025</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>M Nitheeshwar</td>
          <td>210005026</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Maitreya Pathak</td>
          <td>210005027</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Manas Kasliwal</td>
          <td>210005028</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>P. Jaya Vardhan</td>
          <td>210005029</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Pavan Adithya Bandala</td>
          <td>210005030</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>Peram Harish</td>
          <td>210005031</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Prachee Yadav</td>
          <td>210005032</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Pranjal Jaiswal</td>
          <td>210005033</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Prerna Sahu</td>
          <td>210005034</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Priyanshu Kumbhare</td>
          <td>210005035</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Raja Rai</td>
          <td>210005036</td>
        
        </tr>
        <tr>
          <td>34</td>
          <td>Rajveer Jadhav</td>
          <td>210005037</td>
        
        </tr>
        <tr>
          <td>35</td>
          <td>Ritika Gupta</td>
          <td>210005038</td>
        
        </tr>
        <tr>
          <td>36</td>
          <td>Sangvikar Aakash Mahesh</td>
          <td>210005039</td>
        
        </tr>
        <tr>
          <td>37</td>
          <td>Sarvesh Gajanan Aware</td>
          <td>210005040</td>
        
        </tr>
        <tr>
          <td>38</td>
          <td>Shreyas Tiwari</td>
          <td>210005042</td>
        
        </tr>
        <tr>
          <td>39</td>
          <td>Sushant Ranjan Sharma</td>
          <td>210005043</td>
        
        </tr>
        <tr>
          <td>40</td>
          <td>Snehajit Dey</td>
          <td>210005044</td>
        
        </tr>
        <tr>
          <td>41</td>
          <td>Sorakayala Vijay Durga Prasad</td>
          <td>210005045</td>
        
        </tr>
        <tr>
          <td>42</td>
          <td>Soumya Anulom Behera</td>
          <td>210005046</td>
        
        </tr>
        <tr>
          <td>43</td>
          <td>Tanvi Warvadekar</td>
          <td>210005047</td>
        
        </tr>
        <tr>
          <td>44</td>
          <td>Vamshi Krishna Rao</td>
          <td>210005048</td>
        
        </tr>
        <tr>
          <td>45</td>
          <td>Vedant Shankar Patil</td>
          <td>210005050</td>
        
        </tr>
        <tr>
          <td>46</td>
          <td>Vedant Vijay Pimple</td>
          <td>210005051</td>

        </tr>
        <tr>
          <td>47</td>
          <td>Vyankatesh Ghanshyam Chavan</td>
          <td>210005053</td>

        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
   <Accordion.Item eventKey="3">
        <Accordion.Header> <div className="batch">BATCH 2020</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhishek K</td>
          <td>200005002</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Aditi Mishra</td>
          <td>200005003</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Aditya Handa</td>
          <td>200005004</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Akshita Mittal</td>
          <td>200005005</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Anirudha Bhagwat</td>
          <td>200005006</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Anshika Verma</td>
          <td>200005007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Aryan Gupta</td>
          <td>200005008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Botkewar Siddhesh Manish</td>
          <td>200005009</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>C. Karankumar</td>
          <td>200005010</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Daksh Goyal</td>
          <td>200005012</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Doddi Bhavana Devi</td>
          <td>200005013</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Dumpati Vasanth</td>
          <td>200005014</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Gaurav Gill</td>
          <td>200005015</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Gulshan Kumar</td>
          <td>200005016</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Jitin Satish Kumar</td>
          <td>200005018</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Maniratnn Parakh</td>
          <td>200005019</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Manonit Sankhala</td>
          <td>200005020</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Merugu Yuvaraj</td>
          <td>200005021</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Mohammed Zaeem Raees Bichu</td>
          <td>200005022</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Mudit Mohan Ambed</td>
          <td>200005023</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Nain Gupta</td>
          <td>200005024</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Neyasha Sinha</td>
          <td>200005025</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Nikhil Kumar</td>
          <td>200005026</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Nikita Singh</td>
          <td>200005027</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Nilesh Chandel</td>
          <td>200005028</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Nitin Sathish Kumar</td>
          <td>200005029</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Prakhar Gautam</td>
          <td>200005030</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>R. Gokul</td>
          <td>200005031</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Rapartiwar Sahil Saiprasad</td>
          <td>200005032</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Rounak Jain</td>
          <td>200005033</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>S Shrevesh</td>
          <td>200005035</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Saad Ahmed</td>
          <td>200005036</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Sanidhya Kumar</td>
          <td>200005037</td>
        
        </tr>
        <tr>
          <td>34</td>
          <td>Sanket Bhajgawali</td>
          <td>200005038</td>
        
        </tr>
        <tr>
          <td>35</td>
          <td>Sanket Vinayak Muthal</td>
          <td>200005039</td>
        
        </tr>
        <tr>
          <td>36</td>
          <td>Saurav Kumar Yadav</td>
          <td>200005041</td>
        
        </tr>
        <tr>
          <td>37</td>
          <td>Sejal Kotian</td>
          <td>200005042</td>
        
        </tr>
        <tr>
          <td>38</td>
          <td>Shivam Kumar Singh</td>
          <td>200005043</td>
        
        </tr>
        <tr>
          <td>39</td>
          <td>Shreya Singh</td>
          <td>200005044</td>
        
        </tr>
        <tr>
          <td>40</td>
          <td>Sneha Shrivastava</td>
          <td>200005045</td>
        
        </tr>
        <tr>
          <td>41</td>
          <td>Sohail Shaikh</td>
          <td>200005046</td>
        
        </tr>
        <tr>
          <td>42</td>
          <td>Sujal Patel</td>
          <td>200005047</td>
        
        </tr>
        <tr>
          <td>43</td>
          <td>Tatiya Vimalkumar Pramod</td>
          <td>200005048</td>
        
        </tr>
        <tr>
          <td>44</td>
          <td>Vijay Murlidhara N Rao</td>
          <td>200005049</td>
        
        </tr>
        <tr>
          <td>45</td>
          <td>Yash Kumar</td>
          <td>200005050</td>
        
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header> <div className="batch">BATCH 2019</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhishek Dhangar</td>
          <td>190005001</td>
        </tr> 
        <tr>
          <td>2</td>
          <td>Anandita Prasad</td>
          <td>190005002</td>
        </tr> 
        <tr>
          <td>3</td>
          <td>Ananya Sahu</td>
          <td>190005003</td>
        </tr> 
        <tr>
          <td>4</td>
          <td>Ankit Pandey</td>
          <td>190005004</td>
        </tr> 
        <tr>
          <td>5</td>
          <td>Arambh Choukse</td>
          <td>190005005</td>
        </tr> 
        <tr>
          <td>6</td>
          <td>Arpit Vyas</td>
          <td>190005006</td>
        </tr> 
        <tr>
          <td>7</td>
          <td>Ayush Nath</td>
          <td>190005009</td>
        </tr> 
        <tr>
          <td>8</td>
          <td>Chhavi Rathore</td>
          <td>190005010</td>
        </tr> 
        <tr>
          <td>9</td>
          <td>Danduprolu Lavanya</td>
          <td>190005011</td>
        </tr> 
        <tr>
          <td>10</td>
          <td>Godi Saketh Karthikeya</td>
          <td>190005013</td>
        </tr> 
        <tr>
          <td>11</td>
          <td>Harsh Vardhan Agrawal</td>
          <td>190005016</td>
        </tr> 
        <tr>
          <td>12</td>
          <td>Hemant Kumar</td>
          <td>190005017</td>
        </tr> 
        <tr>
          <td>13</td>
          <td>Indira Vashisth Medepalli</td>
          <td>190005018</td>
        </tr> 
        <tr>
          <td>14</td>
          <td>Ishan Bharti</td>
          <td>190005019</td>
        </tr> 
        <tr>
          <td>15</td>
          <td>Mahanya Kochhar</td>
          <td>190005021</td>
        </tr> 
        <tr>
          <td>16</td>
          <td>Manav Tejas Trivedi</td>
          <td>190005022</td>
        </tr> 
        <tr>
          <td>17</td>
          <td>Manish Sahoo</td>
          <td>190005023</td>
        </tr> 
        <tr>
          <td>18</td>
          <td>Mudit Vyas</td>
          <td>190005024</td>
        </tr> 
        <tr>
          <td>19</td>
          <td>Narayan Kabra</td>
          <td>190005025</td>
        </tr> 
        <tr>
          <td>20</td>
          <td>Nikhil Gupta</td>
          <td>190005026</td>
        </tr> 
        <tr>
          <td>21</td>
          <td>Niraj Kumar</td>
          <td>190005027</td>
        </tr> 
        <tr>
          <td>22</td>
          <td>Piyush Nimbhore</td>
          <td>190005028</td>
        </tr> 
        <tr>
          <td>23</td>
          <td>Ponna Revanth</td>
          <td>190005029</td>
        </tr>  

      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header> <div className="batch">BATCH 2018</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Aadish Godha</td>
          <td>180005001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Abhay Gaikwad</td>
          <td>180005002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Abhishek Kasaudhan</td>
          <td>180005003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Aman Vaishnav</td>
          <td>180005004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Archit Ojha</td>
          <td>180005005</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Arvind Singh</td>
          <td>180005007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Aryaman Sharan</td>
          <td>180005008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Avijeet Gupta</td>
          <td>180005009</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Devashish Kaushik</td>
          <td>180005010</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Gaurav Choudhary</td>
          <td>180005011</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Harsh Rajiv</td>
          <td>180005012</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Kantharaju B T</td>
          <td>180005013</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Madhavaram Vishal</td>
          <td>180005014</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Mo. Ismail Mo. Malekji</td>
          <td>180005015</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Mohanakannan C</td>
          <td>180005016</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Mohit Raj Munot</td>
          <td>180005017</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Parth Thadani</td>
          <td>180005018</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Princee Darshit Sanghavi</td>
          <td>180005020</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Priyanka Satyendra Umre</td>
          <td>180005021</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Pushpalata Priyadarshi</td>
          <td>180005022</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Rashtra Damahe</td>
          <td>180005023</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Rhisav Raj</td>
          <td>180005024</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Sanu Prajapati</td>
          <td>180005026</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Sanyam Jain</td>
          <td>180005027</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Sheetal</td>
          <td>180005028</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Shivansh singh</td>
          <td>180005029</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Sonakshi Gupta</td>
          <td>180005030</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>Sulam Ganesh Yadav</td>
          <td>180005031</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Vanjari Venkat Harshith</td>
          <td>180005033</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Vijeet Reel</td>
          <td>180005034</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Vivek Kumar</td>
          <td>180005035</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Yash Sashikant Kothekar</td>
          <td>180005036</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Yugant Janardhan Nagpure</td>
          <td>180005037</td>
        
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header><div className="batch">BATCH 2017</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhishek Singh</td>
          <td>170005002</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Ananddev Mangish</td>
          <td>170005004</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Anil Meena</td>
          <td>170005005</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Ayush Singhal</td>
          <td>170005006</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Chaitanya Mayank Shah</td>
          <td>170005007</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Divik Patre</td>
          <td>170005008</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Gudimella Sree Yashwanth</td>
          <td>170005009</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Gupili Sai Pranav</td>
          <td>170005010</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Hampa Faazil Hussain</td>
          <td>170005011</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Kaustubh Sanjaykumar Dolas</td>
          <td>170005012</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Mayank Garg</td>
          <td>170005014</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Mudavath Ravi</td>
          <td>170005016</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>N Yashwanth</td>
          <td>170005017</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Najma Golam Mahabub</td>
          <td>170005018</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Nandi Kandi Bhanu Prasad</td>
          <td>170005019</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Nishita Chittora</td>
          <td>170005021</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Parmeshwar</td>
          <td>170005022</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Pradyumna Jagdish Somani</td>
          <td>170005023</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Prerna</td>
          <td>170005024</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Ritesh Kumar Prasad</td>
          <td>170005025</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Sachin Gupta</td>
          <td>170005026</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Sai Murali Karthik Putcha</td>
          <td>170005027</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Saksham Rajput</td>
          <td>170005028</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Satish Sahani</td>
          <td>170005029</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Singh Sahab</td>
          <td>170005030</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Sunny Kumar</td>
          <td>170005032</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Ujjwal Tripathi</td>
          <td>170005033</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>Utsav Singh</td>
          <td>170005034</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Vartika Pathak</td>
          <td>170005036</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Vedant Matta</td>
          <td>170005037</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Vipin Kumar</td>
          <td>170005038</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Vihvesh Jain</td>
          <td>170005039</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Yashwant V Sontakke</td>
          <td>170005040</td>
        
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="8">
        <Accordion.Header><div className="batch">BATCH 2016</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abdul Wasim Khan</td>
          <td>160005001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Abhijeet Singh Tomar</td>
          <td>160005002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Abhishek Kamat</td>
          <td>160005003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Agrawal Aditi Amitesh</td>
          <td>160005004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Amisha Arya</td>
          <td>160005005</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Ashish Singhal</td>
          <td>160005007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Ashutosh Gupta</td>
          <td>160005008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Avijit Pandey</td>
          <td>160005009</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Deshpande Indraneel Sundeep</td>
          <td>160005010</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Emin Varghese</td>
          <td>160005012</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Garvit Sharma</td>
          <td>160005013</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Harsh Lorane</td>
          <td>160005014</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Harsh Ranjan</td>
          <td>160005015</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Ingale Tirthesh Ravindra</td>
          <td>160005016</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Jay Shukla</td>
          <td>160005017</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>ManishKumar Niraj Kumar</td>
          <td>160005018</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Mohammed Hadhi P P</td>
          <td>160005019</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Paswan Shital Rajan</td>
          <td>160005022</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Patil Chetan Eknath</td>
          <td>160005023</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Rahul Bhakrani</td>
          <td>160005025</td>
        
        </tr>
        <tr>
          <td>21</td>
          <td>Rahul PC</td>
          <td>160005026</td>
        
        </tr>
        <tr>
          <td>22</td>
          <td>Rajat Agrawal</td>
          <td>160005027</td>
        
        </tr>
        <tr>
          <td>23</td>
          <td>Rajat Upadhyay</td>
          <td>160005028</td>
        
        </tr>
        <tr>
          <td>24</td>
          <td>Ramteke Mrunmay Sunil</td>
          <td>160005029</td>
        
        </tr>
        <tr>
          <td>25</td>
          <td>Ravi Meena</td>
          <td>160005030</td>
        
        </tr>
        <tr>
          <td>26</td>
          <td>Rijul Bharat Sagar</td>
          <td>160005031</td>
        
        </tr>
        <tr>
          <td>27</td>
          <td>Sagar Goswami</td>
          <td>160005033</td>
        
        </tr>
        <tr>
          <td>28</td>
          <td>Satyam Kumar</td>
          <td>160005034</td>
        
        </tr>
        <tr>
          <td>29</td>
          <td>Shreyas S S</td>
          <td>160005035</td>
        
        </tr>
        <tr>
          <td>30</td>
          <td>Songara Harshal</td>
          <td>160005036</td>
        
        </tr>
        <tr>
          <td>31</td>
          <td>Sonal Anish Jojo</td>
          <td>160005037</td>
        
        </tr>
        <tr>
          <td>32</td>
          <td>Tejavanth Vasu</td>
          <td>160005038</td>
        
        </tr>
        <tr>
          <td>33</td>
          <td>Vullengala Manish Chandra</td>
          <td>160005039</td>
        
        </tr>
        <tr>
          <td>34</td>
          <td>Yash Rajesh Shinde</td>
          <td>160005040</td>
        
        </tr>
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    
   </div>
  
   </>
  )
}

export default UG
